import React, { useState} from 'react';
import "./styles/App.scss";
import Logo from "./FGC---Logo-2020_1.webp"

const QUOTES = [
  "You are enough.",
  "People will always have an opinion on you, but as long as you know yourself and you love yourself.",
  "It's a good day to be kind to yourself.",
  "You can only do your best.",
  "What they say when you're not around says more about them than about you.",
  "If you look at what you have in life, you'll always have more. If you look at what you don't have in life, you'll never have enough.",
  "Remember when getting to where you are felt impossible.",
  "If they make you feel like a burden, you're sharing with the wrong person.",
  "Be the one that pushes people forward instead of pushing them down.",
  "Forgiving yourself is part of growth.",
  "Believing in yourself is where it all begins.",
  "It's okay to let go.",
  "Don't say yes to things that say no to your happiness.",
  "Stop saying 'yes' when you mean 'no'.",
  "The world is a better place with you in it.",
  "Keep going, keep growing.",
  "It is not my job to please everybody.",
  "You don't have to be positive 24/7.",
  "Stop spending your energy in places it isn't appreciated.",
  "Be gentle with yourself if you're not feeling great today.",
  "You can be a good person and still say no.",
  "Be kind to others and be kind to yourself.",
  "Stop telling yourself you aren't good enough because you really are.",
  "Everybody is going at their own pace, you're allowed to do that too.",
  "More people care about you than you could ever imagine.",
  "You have no control over what people say about you when you're not around, so keep being you and let them keep showing who they are.",
  "You deserve to be happy!",
  "Stop trying so hard to be liked by the wrong people.",
  "Slowing down ins't counter productive. Trying to do more than you have the energy for is.",
  "Stop risking your happiness by trying to please everyone else.",
  "One day something is gonna happen and it'll make you stop and realise how far you've come and it's going to be a really, really nice feeling.",
  "communicating is as much about listening as it is talking.",
  "Just getting by when times are hard is a big F*cking achievement.",
  "I don't know who needs to hear this but stop pressuring yourself to produce your best work 24/7 it's not sustainable and you're allowed to take a breather.",
  "Don’t say yes to things that say no to your happiness.",
  "Stop saying yes when you mean no.",
  "The world is a better place with you in it.",
  "Keep going keep growing.",
  "It is not my job to please everybody.",
  "You know when you're not feeling great and instead of being kind to yourself you just keep pressuing yourself to get on with it? You're pushing yourself further and further down. You're gotta start treating yourself the same way you would a good friend. be kind, be patient and give yourself some love.",
  "Spending time with good people, will always make you happy.",
];

function App() {
  const [quote, setQuote] = useState('');
  const [showQuote, setShowQuote] = useState(false); // Add this line

  function generateQuote() {
    const randomIndex = Math.floor(Math.random() * QUOTES.length);
    setQuote(QUOTES[randomIndex]);
  setShowQuote(true);
  }

  function resetPage() {
    setQuote('');
    setShowQuote(false);
  }


  return (
    <div className="App">
      { showQuote ?
      <>
      <img src={Logo} alt="Feel Good Club - Quote of the day" className="logo"/>
        <p className="quote sharing">{quote}</p> 
        <button onClick={resetPage} aria-label="Back">Back</button>
        </>
        : (
          <>
            <img src={Logo} alt="Feel Good Club - Quote of the day" className="logo"/>
            <h1>Quote of the Day:</h1>
            <p className="quote">Click the button to generate a quote.</p>
            <button onClick={generateQuote} aria-label="Generate new quote">Generate Quote</button>
          </>
        )
      }
    </div>
  );
}

export default App;
